/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ListPayrollQuery } from '../models/list-payroll-query';
import { ListPayrollResult } from '../models/list-payroll-result';
import { SeniorityLevelData } from '../models/seniority-level-data';

@Injectable({
  providedIn: 'root',
})
export class PayrollService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation payrollList
   */
  static readonly PayrollListPath = '/api/Payroll/List';

  /**
   * Bérelszámolás listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `payrollList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  payrollList$Plain$Response(params?: {
    body?: ListPayrollQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPayrollResult>> {

    const rb = new RequestBuilder(this.rootUrl, PayrollService.PayrollListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPayrollResult>;
      })
    );
  }

  /**
   * Bérelszámolás listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `payrollList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  payrollList$Plain(params?: {
    body?: ListPayrollQuery
  },
  context?: HttpContext

): Observable<ListPayrollResult> {

    return this.payrollList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPayrollResult>) => r.body as ListPayrollResult)
    );
  }

  /**
   * Bérelszámolás listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `payrollList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  payrollList$Response(params?: {
    body?: ListPayrollQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPayrollResult>> {

    const rb = new RequestBuilder(this.rootUrl, PayrollService.PayrollListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPayrollResult>;
      })
    );
  }

  /**
   * Bérelszámolás listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `payrollList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  payrollList(params?: {
    body?: ListPayrollQuery
  },
  context?: HttpContext

): Observable<ListPayrollResult> {

    return this.payrollList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPayrollResult>) => r.body as ListPayrollResult)
    );
  }

  /**
   * Path part for operation payrollGetSeniorityLevel
   */
  static readonly PayrollGetSeniorityLevelPath = '/api/Payroll';

  /**
   * Szenioritási szint lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `payrollGetSeniorityLevel$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  payrollGetSeniorityLevel$Plain$Response(params?: {
    RequestUserId?: number;
    UserId?: number;
    PositionId?: number;
    SeniorityLevel?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SeniorityLevelData>> {

    const rb = new RequestBuilder(this.rootUrl, PayrollService.PayrollGetSeniorityLevelPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('UserId', params.UserId, {});
      rb.query('PositionId', params.PositionId, {});
      rb.query('SeniorityLevel', params.SeniorityLevel, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SeniorityLevelData>;
      })
    );
  }

  /**
   * Szenioritási szint lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `payrollGetSeniorityLevel$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  payrollGetSeniorityLevel$Plain(params?: {
    RequestUserId?: number;
    UserId?: number;
    PositionId?: number;
    SeniorityLevel?: number;
  },
  context?: HttpContext

): Observable<SeniorityLevelData> {

    return this.payrollGetSeniorityLevel$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<SeniorityLevelData>) => r.body as SeniorityLevelData)
    );
  }

  /**
   * Szenioritási szint lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `payrollGetSeniorityLevel()` instead.
   *
   * This method doesn't expect any request body.
   */
  payrollGetSeniorityLevel$Response(params?: {
    RequestUserId?: number;
    UserId?: number;
    PositionId?: number;
    SeniorityLevel?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SeniorityLevelData>> {

    const rb = new RequestBuilder(this.rootUrl, PayrollService.PayrollGetSeniorityLevelPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('UserId', params.UserId, {});
      rb.query('PositionId', params.PositionId, {});
      rb.query('SeniorityLevel', params.SeniorityLevel, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SeniorityLevelData>;
      })
    );
  }

  /**
   * Szenioritási szint lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `payrollGetSeniorityLevel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  payrollGetSeniorityLevel(params?: {
    RequestUserId?: number;
    UserId?: number;
    PositionId?: number;
    SeniorityLevel?: number;
  },
  context?: HttpContext

): Observable<SeniorityLevelData> {

    return this.payrollGetSeniorityLevel$Response(params,context).pipe(
      map((r: StrictHttpResponse<SeniorityLevelData>) => r.body as SeniorityLevelData)
    );
  }

}
